export default {
    navbar: {//头部信息
        welcomes: 'Welcome to Moneysaver Technology',
        companyName: 'Olindel Mall',
		switch:'Language',
		login:'log on',
		quit:'Log out of login',
		registration:'Free registration',
		homePage:'home page',
		personal:'Personal Center',
		contactService:'contact service',
		mobile:'Mobile version',
		myCart:'cart',
		search:'search for',
		contentSearch:'Please enter a keyword search',
		homepage:'homepage',
		siteActions:'Please log in to the app or scan the code to access the mobile website for operation',
    },
	foots:{//底部信息
		customerService:'PHONE',
		contactAddress:'Contact address',
		QRcode:'Scan QR code',
		obtain:'Obtain high-quality products across the entire network',
		operatedMallApp:'Download the self operated mall app',
		copyright:'Copyright',
		CommercialLicense:'Commercial license',
		AllowsCommercial:'Allows commercial use of the program',
		OpenSourceCode:'Open source code',
		openSource:'The code is all open source',
		WorryFreeAfterSale:'Worry free after sale',
		PerfectAfterSalesServicePeriod:'Perfect after-sales service period',
		UsageDocument:'Usage document',
		tutorialDocuments:'Provide the corresponding tutorial documents',
		corporation:"Xi 'an saving brother network technology Co., LTD   Customer se",
		CustomerServiceWechat:'Customer service wechat',
		or:'or',
		CustomerServiceNumber:'Customer service number',
		address:"Unit 1, Building 1, Langchen Building, No. 13, Gaoxin 4 Road, High-tech Zone, Xi 'an, Shaanxi",
		ScanTheQRCode:'Scan the QR code',
		ContactCustomerService:'Contact customer service',
		
	},
	commodity:{//商品页面数据信息
		sort:'sort',
		none:'There is currently no data available',
		groupBuying:'Group buying',
		collect:'Collect products',
		Collected:'Collected',
		deliveryPrice:'Delivery price',
		share:'Sharing and earning',
		salesVolume:'Sales volume',
		monthlySales:'Monthly sales',
		AlreadyAssembled:'Already assembled',
		quantity:'Quantity',
		buyNow:'BUY NOW',
		shoppingCart:'Add to shopping cart',
		show:'Product display',
		comment:'All comments',
		user:'user',
		characters:'Descriptive text',
		products:'Select recommended products',
		SeeMore:'See more',
		DataLoading:'Data loading',
		DoNotFindTheProduct:'Do not find the product, please search for another keyword, if there is any problem, you can contact customer service wx:maxdlln or xiansqx2019 or xiansqx2019',
		SoldOut:'Sold out',
		ImmediatePurchase:'Immediate purchase',
		HotSellingRecommendation:'Hot selling recommendation',
		Platform:'Platform announcement',
		MakeMoneyShopping:'Make money shopping',
		SavingsRebate:'Savings rebate',
		ShareMoney:'Share money',
		SelectedTopic:'Selected topic',
		wantIt:'I know you want it',
		NumberOfFans:'Number of fans',
		SellerVolume:'Seller volume',
		ComprehensiveScore:'Comprehensive score',
		GoShop:'Go into the shop',
		ImmediateOpening:'Immediate opening',
		distribution:'distribution',
		unit:'$',
		SelectedRecommendedProducts:'Selected Recommended Products',
		
		
	},
	personal:{//个人中心
		homePage:'home page',
		account:'Account Settings',
		orderCenter:'Order Center',
		myOrder:'My Order',
		afterSales:'Return/After Sales',
		address:'Address',
		focusCenter:'Focus Center',
		myCollection:'My Collection',
		myFootprint:'My footprint',
		assetCenter:'Asset Center',
		myWallet:'my wallet',
		myPoints:'My points',
		points:'points',
		discountCoupon:'Discount coupon',
		allOrders:'All Orders',
		obligation:'obligation',
		toBeShipped:'To be shipped',
		goodsToBeReceived:'Goods to be received',
		toBeUsed:'To be used',
		toBeEvaluated:'To be evaluated',
		canceled:'Canceled',
		refunding:'refunding',
		refunded:'Refunded',
		refuseRefund:'Refuse Refund',
		inAGroup:'In a group',
		evaluated:'Evaluated',
		babyInformation:'Cargo Information',
		unitPrice:'Unit price',
		yuan:'yuan',
		dollar:'dollar',
		number:'number',
		disbursements:'Disbursements',
		transactionStatus:'Transaction Status',
		transactionOperations:'Transaction Operations',
		orderNumber:'Order Number',
		productSpecifications:'Product specifications',
		orderDetails:'Order details',
		cancellationOfOrder:'cancellation of order',
		ReasonForCancellation:'Reason for cancellation',
		PleaseEnterTheReasonForCancellation:'Please enter the reason for cancellation',
		refund:'refund',
		ReasonForRefund:'Reason for refund',
		PleaseEnterTheRefundReason:'Please enter the refund reason',
		toPay:'confirm an order',
		reminderShipment:'Reminder shipment',
		confirmReceipt:'Confirm receipt',
		toEvaluate:'To evaluate',
		deleteOrder:'Delete Order',
		payAmount:'Pay Amount',
		refundAmount:'refund amount',
		orderTime:'Order time',
		refundStatus:'Refund status',
		savedShippingAddress:'Saved shipping address',
		phone:'phone',
		createANewShippingAddress:'Create a new shipping address',
		consignee:'consignee',
		phoneNumber:'cell-phone number',
		province:'city',
		DetailedAddress:'Detailed address',
		setAsDefaultAddress:'Set as default address',
		save:'save',
		myBalance:'My Balance',
		withdrawableAmount:'Withdrawable amount',
		accumulatedWithdrawalAmount:'Accumulated withdrawal amount',
		walletDetails:'Wallet details',
		withdrawalRecords:'Withdrawal records',
		typesOf:'types of',
		content:'content',
		time:'time',
		amountOfMoney:'amount of money',
		nameOfAlipay:'Name of Alipay',
		alipayAccount:'Alipay account',
		state:'state',
		withdrawing:'Withdrawing',
		withdrawalSuccessful:'Withdrawal successful',
		withdrawalFailed:'Withdrawal failed',
		pointsDetails:'Points Details',
		productVoucher:'Product voucher',
		universalCoupon:'Universal coupon',
		name:'name',
		fullReduction:'Full reduction',
		periodOfValidity:'period of validity',
		full:'full',
		available:'available',
		validTo:'valid to',
		pleaseSelectACity:'Please enter the city',
		cancellation:'cancellation',
		Confirm:'Confirm',
		PaymentBox:'confirm the payment',
		GoToPay:'Go to pay',
		ApplicationTime:'Application time',
		GroupList:'Group list',
		short:'short',
		HumanSpelling:'Human spelling',
		EndTime:'End time',
		JoinAGroup:'Join a group',
		
	},
	orderDetails:{//订单详情
		takeAProduct:'Take a product',
		paymentSuccessful:'Payment successful',
		sellerShipping:'Seller Shipping',
		commodityInformation:'commodity information',
		putAway:'put away',
		discountAmount:'Discount amount',
		totalAmountOfGoods:'Total amount of goods',
		totalFreightCost:'Total freight cost',
		logisticsInformation:'Logistics information',
		noLogisticsInformationAvailable:'There is currently no logistics information available',
		notes:'notes',
		allProducts:'All products',
		delete:'delete',
		selectAll:'Select All',
		amountTo:'amount to',
		ommediateClosure:'Immediate closure',
		operate:'operate',
		trackingNumber:'tracking number',
		VehicleImage:'Vehicle image',
		ReasonForRejection:'Reason for rejection',
		ReasonForRefundRequest:'Reason for Refund Request',
	},
	personalInformation:{//个人信息
		memberUsers:'nickname',
		pleaseEnterANickname:'Please enter a nickname',
		gender:'gender',
		schoolgirl:'schoolgirl',
		schoolboy:'schoolboy',
		modifyPhoneNumber:'Modify phone number',
		withdrawalAccount:'Withdrawal account',
		setUp:'Set up a withdrawal account to facilitate withdrawal services',
		setUpWithdrawalAccount:'Set up withdrawal account',
		CUSTOMERSERVICE:'CUSTOMER SERVICE',
		CreationTime:'Creation time',
		sendFiles:'send files',
		PleaseEnterContent:'Please enter content',
		sending:'sending',
		MemberUser:'Member user',
		NameOfPayee:'Name of payee',
		theNameOfTheRecipient:'Please enter the name of the recipient',
		yourWithdrawalAccountNumber:'Please enter your withdrawal account number',
		
		
	},
	paymentPage:{//支付页面
		consigneeInformation:'Consignee Information',
		newlyFilledDeliveryAddress:'Newly filled delivery address',
		addressInformation:'There is currently no address information available. Please add the address information',
		freight:'Freight',
		leaveAMessage:'Leave a message to the seller',
		specialNeeds:'You can tell the seller your special needs and need to negotiate with them',
		paymentAccount:'Payment account',
		enterYourPaymentAccount:'Please enter your payment account',
		PaymentScreenshot:'Payment screenshot',
		sentTo:'Sent to',
		submitOrder:'submit order',
		CommentContent:'Comment content',
		score:'score',
		Pictures:'Pictures',
		PleaseFillInTheCommentContent:'Please fill in the comment content',
		comment:'comment',
		quickPayment:'Order submitted successfully, but also one step to grab the goods of love, quick payment',
		theQRCodeToPay:'Please use wechat to scan the QR code to pay',
		AlipayPayment:'Alipay payment',
		PayInSmallChange:'Pay in small change',
		WechatPay:'Wechat Pay',
		ToBePaid:'To be paid',
		FirmPayment:'Firm payment',
		PleaseSelectCoupon:'Please select coupon',
		
	},
	login:{//登录页面
		WeChatQRCodeLogin:'WeChat QR code login',
		welcomeToRegister:'Welcome to register',
		existingAccount:'Existing account',
		logOn:'log on',
		mobileAndEmail:'Mobile phone number',
		password:'password',
		forgotPassword:'forgot password',
		register:'register',
		enterYourPhoneNumber:'Please enter your phone number',
		enterYourEmailNumber:'Please enter your email address',
		enterTheVerificationCode:'Please enter the verification code',
		obtainVerificationCode:'Obtain verification code',
		reacquireInSeconds:'Reacquire in seconds',
		toScanAndLogIn:'Please use WeChat to scan and log in',
		passwordLogin:'Password login',
		registerAnAccount:'Register an account',
		pleaseSetLoginPassword:'Please set login password',
		readAndAccept:'Read and accept',
		UserAgreement:'User Agreement',
		asWellAs:'as well as',
		privacyProtectionStatement:'Privacy Protection Statement',
		submitTo:'submit to',
		pleaseSetTheUsername:'Please set the username',
		VerificationCode:'Verification code',
		
	},
}


// WEBPACK FOOTER //
// ./src/lang/en.js